export enum StatisticField {
  Ecpm = 'ecpm',
  StatCnt = 'statCnt', // Impressions
  StatSum = 'statSum', // Earnings
  StatUniqCnt = 'statUniqCnt',
  StatPercent = 'statPercent',

  PrevStatCnt = 'prevStatCnt',
  Prev30StatCnt = 'prev30StatCnt',
  Prev365StatCnt = 'prev365StatCnt',
  StatCntProfitPercentage = 'statCntProfitPercentage',
  StatCntProfitPercentage30 = 'statCntProfitPercentage30',
  StatCntProfitPercentage365 = 'statCntProfitPercentage365',

  StatRateSum = 'statRateSum',
  RateEcpm = 'rateEcpm',
  BaseStatRateSum = 'baseStatRateSum',
  BaseRateEcpm = 'baseRateEcpm',
  UserEarningRate = 'userEarningRate',
  EarningRate = 'earningRate',
  EarningsMultiplier = 'earningsMultiplier',
  UserEarningsMultiplier = 'userEarningsMultiplier',
}

export const statisticLabels = {
  [StatisticField.Ecpm]: 'ECPM',
  [StatisticField.StatCnt]: 'Impressions',
  [StatisticField.StatSum]: 'Earnings',
  [StatisticField.StatUniqCnt]: 'Unique Impressions',
  [StatisticField.StatPercent]: 'Traffic Volume',
  [StatisticField.StatRateSum]: 'REarnings',
  [StatisticField.RateEcpm]: 'RECPM',
  [StatisticField.StatCntProfitPercentage]: 'IP Day',
  [StatisticField.StatCntProfitPercentage30]: 'IP Month',
  [StatisticField.StatCntProfitPercentage365]: 'IP Year',
};
